export enum FileStatus {
  Persisted = 1,
  New = 2,
  Updated = 3,
  Removed = 4
}